// extracted by mini-css-extract-plugin
export const SignupForm = "SignupForm-module--SignupForm--2sBgy";
export const FormHeading = "SignupForm-module--FormHeading--3cPV5";
export const ButtonLink = "SignupForm-module--ButtonLink--1PkpI";
export const SuccessContainer = "SignupForm-module--SuccessContainer--18fT3";
export const SuccessMsg = "SignupForm-module--SuccessMsg--1MJCt";
export const TrackButton = "SignupForm-module--TrackButton--3Ij68";
export const ErrorMsg = "SignupForm-module--ErrorMsg--1jdhr";